"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppliedWhereRuleNameToMatchCondition = exports.isMatchExpressionValue = exports.MatchExpressionType = exports.MatchExpressionOperatorType = exports.FOREST_RIVER_MERCHANT_CODES = exports.TYPE_FIVE_MERCHANT_CODE = exports.SEMPER_FI_MERCHANT_CODE = exports.TRAVEL_MCC_CODES = exports.TRAVEL_GENERIC_TRANSPORTATION_MCC_CODES = exports.TRAVEL_LODGING_MCC_CODES = exports.TRAVEL_AUTOMOBILE_RENTAL_MCC_CODES = exports.TRAVEL_AIRLINE_MCC_CODES = exports.HOME_IMPROVEMENT_MCC_CODES = exports.HOME_IMPROVEMENT_SPECIALTY_RETAIL_MCC_CODES = exports.HOME_IMPROVEMENT_HOME_SUPPLY_RETAIL_MCC_CODES = exports.HOME_IMPROVEMENT_CONTRACTOR_MCC_CODES = exports.UTILITIES_GAS_AND_EV_CHARGING_MCC_CODES = exports.GAS_GROCERIES_AND_UTILITIES_MCC_CODES = exports.RESTAURANTS_MCC_CODES = exports.GAS_AND_GROCERIES_MCC_CODES = exports.GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS_MCC_CODES = exports.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES = exports.DUNKIN_MERCHANT_NAME = exports.STARBUCKS_MERCHANT_NAME = exports.HOME_DEPOT_MERCHANT_NAMES = exports.POINT_OF_SALE_MERCHANTS = exports.AppliedWhereRuleNames = void 0;
const mccCode_1 = require("./mccCode");
var AppliedWhereRuleNames;
(function (AppliedWhereRuleNames) {
    AppliedWhereRuleNames["HOME_DEPOT"] = "home_depot";
    AppliedWhereRuleNames["GROCERIES_AND_SUPERMARKETS"] = "groceries_and_supermarkets";
    AppliedWhereRuleNames["GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES"] = "groceries_supermarkets_and_misc_food_stores";
    AppliedWhereRuleNames["GAS_STATIONS"] = "gas_stations";
    AppliedWhereRuleNames["GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS"] = "gas_stations_and_automated_fuel_dispensers";
    AppliedWhereRuleNames["GAS_GROCERIES_AND_UTILITIES"] = "gas_groceries_and_utilities";
    AppliedWhereRuleNames["AUTOMATED_FUEL_DISPENSERS"] = "automated_fuel_dispensers";
    AppliedWhereRuleNames["RESTAURANTS"] = "restaurants";
    AppliedWhereRuleNames["STARBUCKS_DUNKIN"] = "starbucks_dunkin";
    AppliedWhereRuleNames["GAS_AND_GROCERIES"] = "gas_and_groceries";
    AppliedWhereRuleNames["POINT_OF_SALE_MERCHANTS"] = "point_of_sale_merchants";
    AppliedWhereRuleNames["SEMPER_FI_MERCHANT"] = "semper_fi_merchant";
    AppliedWhereRuleNames["TYPE_FIVE_MERCHANT"] = "type_five_merchant";
    AppliedWhereRuleNames["FOREST_RIVER_MERCHANTS"] = "forest_river_merchants";
    AppliedWhereRuleNames["DB_MERCHANT_CODES"] = "db_merchant_codes";
    AppliedWhereRuleNames["UNRESTRICTED"] = "unrestricted";
    AppliedWhereRuleNames["HOA_PAYMENTS"] = "hoa_payments";
    AppliedWhereRuleNames["TRAVEL"] = "travel";
    AppliedWhereRuleNames["HOME_IMPROVEMENT"] = "home_improvement";
    AppliedWhereRuleNames["UTILITIES_GAS_AND_EV_CHARGING"] = "utilities_gas_and_ev_charging";
})(AppliedWhereRuleNames || (exports.AppliedWhereRuleNames = AppliedWhereRuleNames = {}));
// Applied Where merchants
// Merchant Names
/**
 * List of merchants that are eligible for the point of sale 5% cashback boost rewards.
 * https://docs.google.com/document/d/1Cm4p2wDmznaDS5C8mXWt5C54-u2kk4p9jpHWBA9dcG4/edit?tab=t.0#heading=h.lhfbe2tv2rh2
 * We will be changing the merchants this applies for as we add more merchants to the program.
 * https://docs.google.com/spreadsheets/d/1cFR4q4poq4UPwrMwVwB9HlnhcfP6i8anvVIeOzouC3E/edit?gid=0#gid=0
 */
exports.POINT_OF_SALE_MERCHANTS = [
    `Franklin's Ace Hardware`,
    `Franklins Ace Hardware & Garden`,
    `Discount Pool Mart Inc`,
    `Vista Paint`,
    `LARRY AND JOE S PLUM`,
    `Maman Wallcovering Company`,
    `Shilpark Paint`,
    `Epic interiors inc`,
    `Ferrufino Interiors`,
    `Jackson Market`,
    `Reeds Furniture`,
    `A1 Appliance Parts`,
    `Whileshire LED lighting`,
    `SO CAL FLOORING AND CABINETS INC.`,
    `CabCo Cabinets`,
    `Ventura Stone Care`,
    `Re-Bath`,
    `Appliance For Less`,
    `GRW Furniture`,
    `Garnica's Contruction Inc`,
    `One Stop Lighting`,
    `Interiors Made Eezzy`,
    `Emil's Hardware`,
    `Carpet Studio`,
    `Designer Door & Window`,
    `Urban Habitat`,
    `Coverall Industries`,
    `ALA PRO`,
    `Anderson Plywood`,
    `Cosmos Flooring`,
    `The Kitchen Store`,
    `Ventura Flooring`,
    `Pasadena Kitchens`,
    `Mattress Store Pasadena`,
    `East LA Wholesale Electric`,
    `de-cor`,
    `Granite Center Kitchen and Bath`,
    `Ferguson Plumbing Supply`,
    `Mikes Brooklyn Hardware`,
    `Lusive Decor`,
    `Mario Capasa`,
    `Koontz Hardware`,
    `B. David Levine`,
    `Wood Ave`,
    `Royal-Pedic Mattress`,
    `Buy Rite Electric`,
    `Designer Import`,
    `Gramar Stone Center Inc`,
    `EUROCRAFT CABINETRY INC`,
    `iDecor Flooring`,
    `Starbridge Window's & Doors`,
    `Aaroha Radiant`,
    `MTD Kitchen`,
    `Bella Stones Inc.`,
    `GLC Cabinet Inc`,
    `Stone Dock & Design`,
    `Cox Paint Inc`,
    `PK Electric Supply`,
    `INCA Kitchen & Bath Inc.`,
    `Forma Design Center Inc`,
    `ReFloors Inc`,
    `Marble Bros Tile & Stone`,
    `PPG Paint`,
    `Maxims Furniture Inc`,
    `Firenze Tile`,
    `Reece Plumbing`,
    `Ferguson Ent`,
    `Vertex Developers Inc.`,
    `Inglewood Pipe & Hardware`,
    `Hawthorne Hardware`,
    `cooks doors and windows `,
    `Branch 5003`,
    `Cal Tile Cenrer`,
    `Rexel 2613`,
    `Hajoca Hawthorne`,
    `Seers Lumber Co Inc`,
    `Signature Tile & Stone`,
    `Elevated Kitchens & More`,
    `San Dimas hardware`,
    `Palata tile and stone`,
    `Hometime Windows & Doors`,
    `lindo innovation inc `,
    `Thermetron Inc`,
    `Westwood Power Tools`,
    `Hajoca Jefferson`,
    `International Flooring Center Inc.`,
    `Hirsch Pipe & Supply`,
    `Alfi Properties LLC`,
    `United Home Remodeling INC`,
    `Newform Kitchen & More`,
    `Patagonia Building Supplies`,
];
exports.HOME_DEPOT_MERCHANT_NAMES = ['home depot', 'homedepot'];
exports.STARBUCKS_MERCHANT_NAME = 'starbucks';
exports.DUNKIN_MERCHANT_NAME = 'dunkin';
// Merchant Category Codes
exports.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES = [mccCode_1.MccCode.GROCERIES_AND_SUPERMARKETS, mccCode_1.MccCode.MISCELLANEOUS_FOOD_STORES];
exports.GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS_MCC_CODES = [mccCode_1.MccCode.SERVICE_STATIONS, mccCode_1.MccCode.AUTOMATED_FUEL_DISPENSERS];
exports.GAS_AND_GROCERIES_MCC_CODES = [...exports.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES, ...exports.GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS_MCC_CODES];
exports.RESTAURANTS_MCC_CODES = [mccCode_1.MccCode.RESTAURANTS, mccCode_1.MccCode.FAST_FOOD];
exports.GAS_GROCERIES_AND_UTILITIES_MCC_CODES = [...exports.GAS_AND_GROCERIES_MCC_CODES, mccCode_1.MccCode.UTILITIES, mccCode_1.MccCode.CABLE];
// Rewards OG category-selection boost categories (see design doc §6).
// Utilities, gas stations, and EV charging
exports.UTILITIES_GAS_AND_EV_CHARGING_MCC_CODES = [mccCode_1.MccCode.UTILITIES, mccCode_1.MccCode.SERVICE_STATIONS, mccCode_1.MccCode.AUTOMATED_FUEL_DISPENSERS, mccCode_1.MccCode.EV_CHARGING];
// Home improvement — contractors, home-supply retail, and specialty retail
exports.HOME_IMPROVEMENT_CONTRACTOR_MCC_CODES = [
    mccCode_1.MccCode.GENERAL_CONTRACTORS,
    mccCode_1.MccCode.HEATING_PLUMBING_AND_AIR_CONDITIONING,
    mccCode_1.MccCode.ELECTRICAL_CONTRACTORS,
    mccCode_1.MccCode.MASONRY_AND_TILE_SETTING,
    mccCode_1.MccCode.CARPENTRY_CONTRACTORS,
    mccCode_1.MccCode.ROOFING_AND_SIDING,
    mccCode_1.MccCode.CONCRETE_WORK,
    mccCode_1.MccCode.SPECIAL_TRADE_CONTRACTORS,
];
exports.HOME_IMPROVEMENT_HOME_SUPPLY_RETAIL_MCC_CODES = [
    mccCode_1.MccCode.HOME_SUPPLY_WAREHOUSE_STORES,
    mccCode_1.MccCode.BUILDING_MATERIALS_AND_LUMBER,
    mccCode_1.MccCode.GLASS_PAINT_AND_WALLPAPER,
    mccCode_1.MccCode.HARDWARE_STORES,
    mccCode_1.MccCode.LAWN_AND_GARDEN_SUPPLY,
];
exports.HOME_IMPROVEMENT_SPECIALTY_RETAIL_MCC_CODES = [mccCode_1.MccCode.FLOOR_COVERING_STORES, mccCode_1.MccCode.DRAPERY_AND_WINDOW_COVERING, mccCode_1.MccCode.FIREPLACE_AND_FIREPLACE_SCREENS];
exports.HOME_IMPROVEMENT_MCC_CODES = [...exports.HOME_IMPROVEMENT_CONTRACTOR_MCC_CODES, ...exports.HOME_IMPROVEMENT_HOME_SUPPLY_RETAIL_MCC_CODES, ...exports.HOME_IMPROVEMENT_SPECIALTY_RETAIL_MCC_CODES];
// Travel — airlines, automobile rentals, lodging, and generic transportation. The three issuer blocks carry
// the design-doc ranges instead of naming 783 codes that differ only by an increment (see MccCodeBlock).
exports.TRAVEL_AIRLINE_MCC_CODES = [mccCode_1.MccCode.AIRLINES_ISSUER_BLOCK];
exports.TRAVEL_AUTOMOBILE_RENTAL_MCC_CODES = [mccCode_1.MccCode.AUTOMOBILE_RENTAL_ISSUER_BLOCK];
exports.TRAVEL_LODGING_MCC_CODES = [mccCode_1.MccCode.LODGING_ISSUER_BLOCK];
exports.TRAVEL_GENERIC_TRANSPORTATION_MCC_CODES = [
    mccCode_1.MccCode.RAILROADS,
    mccCode_1.MccCode.COMMUTER_TRANSPORTATION_INCLUDING_FERRIES,
    mccCode_1.MccCode.PASSENGER_RAILWAYS,
    mccCode_1.MccCode.TAXICABS_AND_LIMOUSINES,
    mccCode_1.MccCode.STEAMSHIP_AND_CRUISE_LINES,
    mccCode_1.MccCode.AIRLINES_NOT_ELSEWHERE_CLASSIFIED,
    mccCode_1.MccCode.TRAVEL_AGENCIES_AND_TOUR_OPERATORS,
    mccCode_1.MccCode.TOLLS_AND_BRIDGE_FEES,
    mccCode_1.MccCode.TRANSPORTATION_SERVICES_NOT_ELSEWHERE_CLASSIFIED,
    mccCode_1.MccCode.LODGING_HOTELS_AND_MOTELS,
    mccCode_1.MccCode.AUTOMOBILE_RENTAL_AGENCIES,
    mccCode_1.MccCode.PARKING_LOTS_AND_GARAGES,
];
exports.TRAVEL_MCC_CODES = [...exports.TRAVEL_AIRLINE_MCC_CODES, ...exports.TRAVEL_AUTOMOBILE_RENTAL_MCC_CODES, ...exports.TRAVEL_LODGING_MCC_CODES, ...exports.TRAVEL_GENERIC_TRANSPORTATION_MCC_CODES];
exports.SEMPER_FI_MERCHANT_CODE = '24193044293006143542304'; // Merchant code for 'Semper Fi Home Services' from CoreCard.
exports.TYPE_FIVE_MERCHANT_CODE = '5247716131866516'; // Merchant code for 'Type Five' from CoreCard.
// TODO: replace these placeholders with the real Forest River dealer merchant IDs before launch.
exports.FOREST_RIVER_MERCHANT_CODES = ['900000000000001', '900000000000002', '900000000000003'];
var MatchExpressionOperatorType;
(function (MatchExpressionOperatorType) {
    MatchExpressionOperatorType["and"] = "and";
    MatchExpressionOperatorType["or"] = "or";
})(MatchExpressionOperatorType || (exports.MatchExpressionOperatorType = MatchExpressionOperatorType = {}));
var MatchExpressionType;
(function (MatchExpressionType) {
    MatchExpressionType["merchantName"] = "merchantName";
    MatchExpressionType["merchantCategoryCode"] = "merchantCategoryCode";
    MatchExpressionType["merchantCode"] = "merchantCode";
    MatchExpressionType["merchantCodesFromDb"] = "merchantCodesFromDb";
    MatchExpressionType["unrestricted"] = "unrestricted";
})(MatchExpressionType || (exports.MatchExpressionType = MatchExpressionType = {}));
const isMatchExpressionValue = (matchExpressionOrMatchExpressionValue) => {
    return 'value' in matchExpressionOrMatchExpressionValue && 'type' in matchExpressionOrMatchExpressionValue;
};
exports.isMatchExpressionValue = isMatchExpressionValue;
exports.AppliedWhereRuleNameToMatchCondition = {
    [AppliedWhereRuleNames.HOME_DEPOT]: {
        left: {
            value: exports.HOME_DEPOT_MERCHANT_NAMES,
            type: MatchExpressionType.merchantName,
        },
        right: {
            value: [mccCode_1.MccCode.HOME_SUPPLY_WAREHOUSE_STORES],
            type: MatchExpressionType.merchantCategoryCode,
        },
        operator: MatchExpressionOperatorType.and,
    },
    [AppliedWhereRuleNames.GROCERIES_AND_SUPERMARKETS]: {
        value: [mccCode_1.MccCode.GROCERIES_AND_SUPERMARKETS],
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.GAS_STATIONS]: {
        value: [mccCode_1.MccCode.SERVICE_STATIONS],
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.AUTOMATED_FUEL_DISPENSERS]: {
        value: [mccCode_1.MccCode.AUTOMATED_FUEL_DISPENSERS],
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS]: {
        value: exports.GAS_STATIONS_AND_AUTOMATED_FUEL_DISPENSERS_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.RESTAURANTS]: {
        value: exports.RESTAURANTS_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.STARBUCKS_DUNKIN]: {
        left: {
            value: [exports.STARBUCKS_MERCHANT_NAME, exports.DUNKIN_MERCHANT_NAME],
            type: MatchExpressionType.merchantName,
        },
        right: {
            value: [mccCode_1.MccCode.RESTAURANTS, mccCode_1.MccCode.FAST_FOOD],
            type: MatchExpressionType.merchantCategoryCode,
        },
        operator: MatchExpressionOperatorType.and,
    },
    [AppliedWhereRuleNames.GAS_AND_GROCERIES]: {
        value: exports.GAS_AND_GROCERIES_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.GAS_GROCERIES_AND_UTILITIES]: {
        value: exports.GAS_GROCERIES_AND_UTILITIES_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.POINT_OF_SALE_MERCHANTS]: {
        value: exports.POINT_OF_SALE_MERCHANTS,
        type: MatchExpressionType.merchantName,
    },
    [AppliedWhereRuleNames.SEMPER_FI_MERCHANT]: {
        value: [exports.SEMPER_FI_MERCHANT_CODE],
        type: MatchExpressionType.merchantCode,
    },
    [AppliedWhereRuleNames.TYPE_FIVE_MERCHANT]: {
        value: [exports.TYPE_FIVE_MERCHANT_CODE],
        type: MatchExpressionType.merchantCode,
    },
    [AppliedWhereRuleNames.FOREST_RIVER_MERCHANTS]: {
        value: exports.FOREST_RIVER_MERCHANT_CODES,
        type: MatchExpressionType.merchantCode,
    },
    [AppliedWhereRuleNames.DB_MERCHANT_CODES]: {
        value: [],
        type: MatchExpressionType.merchantCodesFromDb,
    },
    [AppliedWhereRuleNames.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES]: {
        value: exports.GROCERIES_SUPERMARKETS_AND_MISC_FOOD_STORES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.UNRESTRICTED]: {
        value: [],
        type: MatchExpressionType.unrestricted,
    },
    [AppliedWhereRuleNames.HOA_PAYMENTS]: {
        value: [],
        type: MatchExpressionType.unrestricted,
    },
    [AppliedWhereRuleNames.TRAVEL]: {
        value: exports.TRAVEL_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.HOME_IMPROVEMENT]: {
        value: exports.HOME_IMPROVEMENT_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
    [AppliedWhereRuleNames.UTILITIES_GAS_AND_EV_CHARGING]: {
        value: exports.UTILITIES_GAS_AND_EV_CHARGING_MCC_CODES,
        type: MatchExpressionType.merchantCategoryCode,
    },
};
